<template>
  <div class="tmAdEdit">
    <el-tabs :stretch="true" value="style">
      <el-tab-pane
        :label="$t('lcd.Editor.Style')"
        name="style"
        class="style-pane"
      >
        <attr-row
          :label="$t('lcd.Editor.Layer Name') + ' : ' + conf.name"
        ></attr-row>
        <attr-row
          class="custom-smaller-btn"
          :label="$t('lcd.Editor.Position and Size')"
        >
          <!-- 兼容横屏模板:disabled="conf.width == 480" -->
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.left"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              :disabled="conf.width == 480"
              @change="changeRangeX"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">X</div>
              </template>
            </el-input>
            <el-input
              v-model="conf.top"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              :disabled="conf.width == 480"
              @change="changeRangeY"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">Y</div>
              </template>
            </el-input>
          </div>
          <div style="height: 5px"></div>
          <div style="display: flex; justify-content: space-between">
            <el-input
              v-model="conf.width"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeW"
            >
              <template slot="prepend">
                <div style="width: 12px; text-align: center">W</div>
              </template>
            </el-input>
            <el-input
              v-model="conf.height"
              controls-position="right"
              type="number"
              size="mini"
              style="width: 49%"
              @change="changeRangeH"
            >
              <template slot="prepend"
                ><div style="width: 12px; text-align: center">H</div></template
              >
            </el-input>
          </div>
        </attr-row>
        <attr-row :label="$t('lcd.Editor.Default Ad')" class="tl">
          <div
            class="video-item"
            v-for="(it, index) in conf.adList"
            :key="index"
          >
            <video
              width="240px"
              height="120px"
              :src="it.url"
              :key="it.videoId"
            />
            <el-tooltip
              class="item"
              effect="dark"
              :content="$t('lcd.Editor.Change Video')"
              placement="top"
            >
              <el-button
                size="mini"
                icon="el-icon-refresh"
                circle
                @click="handleClickVideo(index)"
              >
              </el-button>
            </el-tooltip>
          </div>
        </attr-row>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import store from "../../../store/index.js";
import AttrRow from "../../tumeng-attr-row/src/index.vue";

export default {
  name: "TumengAdEdit",
  data() {
    return {
      state: store.state,
      canvasWidth: store.state.programInfo.width,
      canvasHeight: store.state.programInfo.height,
    };
  },
  components: { AttrRow },
  model: {
    prop: "activeComponent",
    event: "vmu",
  },
  computed: {
    conf() {
      return store.state.activeComponent;
    },
  },
  methods: {
    // 删除视频
    handleClickVideo(index) {
      console.log(this.conf.adList);
      store.SET_SELECT_VIDEO_OPERATION("REPLACE_AD");
      store.updateSelectVideoDialogVisible(true);
      return;
      if (this.conf.adList.length > 1) {
        this.conf.adList.splice(index, 1);
      } else {
        this.$message({
          type: "warning",
          message: "至少需要一个视频",
          duration: 2000,
        });
      }
    },

    /**
     * 添加视频
     */
    handleClickAddVideo() {
      store.SET_SELECT_VIDEO_OPERATION("ADD_VIDEO");
      store.updateSelectVideoDialogVisible(true);
    },

    changeRangeX(e) {
      console.log("X", e);
      console.log(this.canvasWidth, this.canvasHeight);
      let confX = +e;
      if (confX > this.canvasWidth - this.conf.width) {
        confX = this.canvasWidth - this.conf.width;
      }
      if (confX < 0) {
        confX = 0;
      }
      this.conf.left = confX;
    },
    changeRangeY(e) {
      let confY = +e;
      if (confY > this.canvasHeight - this.conf.height) {
        confY = this.canvasHeight - this.conf.height;
      }
      if (confY < 0) {
        confY = 0;
      }
      this.conf.top = confY;
    },
    changeRangeW(e) {
      let confW = +e;
      if (confW > this.canvasWidth - this.conf.left) {
        confW = this.canvasWidth - this.conf.left;
      }
      if (confW < 0) {
        confW = 0;
      }
      this.conf.width = confW;
    },
    changeRangeH(e) {
      let confH = +e;
      if (confH > this.canvasHeight - this.conf.top) {
        confH = this.canvasHeight - this.conf.top;
      }
      if (confH < 0) {
        confH = 0;
      }
      this.conf.height = confH;
    },
  },
};
</script>

<style lang="scss" scoped>
.tmAdEdit {
  margin: 8px;
  ::v-deep .el-tabs__item {
    &.is-active {
      color: #3461ff;
    }
  }

  .video-item {
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .add-video {
    margin-top: 10px;
  }

  .style-pane {
    // 横纵坐标、宽高样式
    @import "../../../assets/style/ltwh";

    > .custom-smaller-slider-btn2 {
      // slider的拖拽点变小
      ::v-deep .el-slider__button {
        border-width: 1px;
        width: 10px;
        height: 10px;
      }
      // slider宽度
      ::v-deep .el-slider {
        width: calc(100% - 76px);
        margin-right: 16px;
        float: left;
      }
      // 隐藏数字输入框的增加、减少按钮
      ::v-deep span.el-input-number__increase,
      ::v-deep span.el-input-number__decrease {
        display: none;
      }
      // 设置数字输入框的padding
      ::v-deep input.el-input__inner {
        padding: 0;
      }
      /*指定输入框宽度*/
      ::v-deep .el-input-number.el-input-number--mini {
        width: 60px;
        float: left;
        margin-top: 5px;
      }
    }
  }
  .prop-pane {
    // 添加视频按钮变宽
    button.el-button.el-button--default.el-button--small {
      width: 100%;
    }
    // 给装视频的div指定样式
    > div {
      margin: 4px 12px 4px 4px;
      padding: 4px;
      border: 1px dashed white;
      position: relative;
      height: 100px;
      &:after {
        content: "";
        display: block;
        clear: both;
      }
      > video {
        float: left;
      }
      > button.el-button.el-button--default.el-button--mini.is-circle {
        position: absolute;
        padding: 0;
        right: 0;
        top: 50%;
        transform: translate(50%, -50%);
      }
    }
  }
}
</style>
<style lang="scss">
.tmAdEdit .el-input-group__append,
.tmAdEdit .el-input-group__prepend {
  padding: 0 10px;
}

.tmAdEdit {
  button.el-button.el-button--default.el-button--mini.is-circle {
    padding: 0 2px;
    height: 20px;
  }
  .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
  }
}
</style>